import { NgModule } from '@angular/core';
import { CommonModule } from 'common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ShareOfferComponent } from './share-offer.component';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { SendOfferEmailComponent } from './send-offer-email/send-offer-email.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
  ],
  declarations: [
    ShareOfferComponent,
    SendOfferEmailComponent
  ],
  exports: [
    ShareOfferComponent,
    SendOfferEmailComponent
  ],
  providers: [
    PercentPipe,
    CurrencyPipe
  ]
})
export class ShareOfferModule { }
